import { mapGetters } from 'vuex'

// function to sum prices of campsites
function sumPrices (totals, booking) {
  totals.retail += Number(booking.retailPrice)
  totals.price += Number(booking.price)
  return totals
}
// starting state
const initialTotals = {
  retail: 0,
  price: 0
}

export default {
  totals: {
    computed: {
      ...mapGetters({
        campsiteBookings: 'cart/campsiteBookings',
        parkingBookings: 'cart/parkingBookings',
        gatePasses: 'cart/gatePasses',
        otherCharges: 'cart/otherCharges',
        workingInvoice: 'invoices/workingInvoice'
      }),
      campsiteTotals () {
        // if they aren't loaded yet return 0
        if (this.campsiteBookings.length < 1) {
          return initialTotals
        }
        // reduce.
        // 0 starting value required. prevents use of object as initial value
        return this.campsiteBookings.reduce(sumPrices, { ...initialTotals })
      },
      parkingTotals () {
        // if they aren't loaded yet return 0
        if (this.parkingBookings.length < 1) {
          return initialTotals
        }
        // reduce.
        // 0 starting value required. prevents use of object as initial value
        return this.parkingBookings.reduce(sumPrices, { ...initialTotals })
      },
      gatePassTotals () {
        // if they aren't loaded yet return 0
        if (this.gatePasses.length < 1) {
          return initialTotals
        }
        // reduce.
        // 0 starting value required. prevents use of object as initial value
        return this.gatePasses.reduce(sumPrices, { ...initialTotals })
      },
      subTotal () {
        return this.campsiteTotals.price + this.parkingTotals.price + this.gatePassTotals.price
      },
      otherChargeTotal () {
        if (this.otherCharges.length < 1) {
          return 0
        }
        // 0 starting value required. prevents use of object as initial value
        return this.otherCharges.reduce((total, charge) => {
          return total + Number(charge.price)
        }, 0)
      },
      grandTotal () {
        return this.subTotal + this.otherChargeTotal
      }
    }
  }
}
